import React from 'react';

/**
 * SubGroupItem Component
 * Renders a single subgroup filter item.
 * 
 * Task: P2-003
 */
const SubGroupItem = ({
  subgroup,
  isSelected,
  isZeroCount,
  onToggle
}) => {
  const count = subgroup.count || 0;
  const combinedCode = `${subgroup.main_group_code}${subgroup.subgroup_code}`;
  
  return (
    <label
      className={`block p-2 rounded-lg cursor-pointer transition-colors ${
        isSelected ? 'bg-orange-50 border border-orange-200' : 
        isZeroCount ? 'opacity-50 bg-slate-50' : 'hover:bg-slate-50'
      }`}
      data-testid={`filter-subgroup-${subgroup.main_group_code}-${subgroup.subgroup_code}`}
    >
      <div className="flex items-start space-x-2">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => onToggle(subgroup.main_group_code, subgroup.subgroup_code)}
          className="w-4 h-4 mt-0.5 text-orange-600 border-slate-300 rounded focus:ring-orange-500"
        />
        <div className="flex-1 min-w-0">
          <div className={`text-sm ${isZeroCount ? 'text-slate-400' : 'text-slate-700'}`}>
            {subgroup.name}
          </div>
          <div className="text-xs text-slate-400 mt-0.5 flex items-center justify-between">
            <span>↳ <span className="font-mono">{combinedCode}</span></span>
            <span className="font-mono">({count})</span>
          </div>
        </div>
      </div>
    </label>
  );
};

export default SubGroupItem;
